import {createXRStore} from '@react-three/xr';

// Create XR store with configuration
export const xrStore = createXRStore({
  // Enable hand tracking
  hand: true,
  // Enable controllers
  controller: {
    left: true,
    right: true,
  },
});
